<template lang="html">
  <vue-apex-charts
    ref="chart"
    type="donut"
    height="260"
    :options="resumoSinaisChartOptions"
    :series="series"
  />
</template>

<script>
/* eslint-disable */
import VueApexCharts from 'vue-apexcharts'

  export default {
    name: "GraficoSinal",

    components: {
        VueApexCharts,
    },

    props: {
      resumoSinal: {
        default: []
      },
      series: {
        default: []
      },
      hideLabels: {
        type: Boolean,
        default: false
      }
    },

     computed: {

        windowWidth() {
            return this.$store.state.app.windowWidth
        },

        resumoSinaisChartOptions() {
        const _self = this
        const config = {
          noData: {
            text: 'Loading...',
          },
          colors: ['#8b8f98', '#4ade80', '#f87171'],
          labels: [_self.$i18n.t('textAtivos'),_self.$i18n.t('textGanhos'), _self.$i18n.t('textPerdas')],
          dataLabels: {
            enabled: false,
            formatter(val) {
              // eslint-disable-next-line radix
              return `${parseInt(val)}%`
            },
          },
          chart: {
            type: 'donut',
          },
          fill: {
            type: 'gradient',
          },
          plotOptions: {
            pie: {
              startAngle: -120,
              endAngle: 120,
              offsetY: 10,
              donut: {
                size: '85%',
                labels: {
                  show: true,
                  name: {
                    fontSize: '1rem',
                    fontWeight: '900',
                    fontFamily: 'Geist',
                  },
                  value: {
                    show: true,
                    fontSize: '1rem',
                    fontWeight: '900',
                    fontFamily: 'Geist',
                    formatter(val) {
                      return `${val}%`
                    },
                  },
                  total: {
                    show: true,
                    fontSize: '1.5rem',
                    fontWeight: '900',
                    label: _self.resumoSinal.total > 0 ? _self.$i18n.t('Sinais') : '',
                    formatter() {
                        return _self.resumoSinal.total > 0 ? _self.resumoSinal.total : _self.$i18n.t('textSemOperacao')
                    },
                  },
                },
              },
  
            },
          },
          grid: {
            padding: {
              bottom: -40,
            },
          },
          legend: {
            show: !_self.hideLabels,
            position: 'bottom',
            fontSize: '16px',
            fontFamily: 'Geist',
            showForZeroSeries: true,
            formatter(seriesName, opts) {
              let qtde = 0
              if (seriesName == _self.$i18n.t('textAtivos')) {
                qtde = _self.resumoSinal.totalAtivo
              } else if (seriesName == _self.$i18n.t('textGanhos')) {
                qtde = _self.resumoSinal.totalGanho
              } else if (seriesName == _self.$i18n.t('textPerdas')) {
                qtde = _self.resumoSinal.totalPerda
              }
              return `
                  <div class='mr-1 mt-1' style="display: flex; flex-direction: column; align-items: center;">
                    <span style="position: relative; font-size: 16px;">${seriesName}</span>
                    <span style="font-size: 16px;">${qtde}</span>
                  </div>
                `;
              },
          },
        }
        return config
      },
     }
  }
</script>
<style lang="scss">
@import '@core/scss/vue/libs/chart-apex.scss';
</style>